<script>
import Config from '@/config';
import {myOrders} from '@/api';
import Size from '@/mixins/size';
import {pageIsFinish} from '@/libs/util';
import {List, PullRefresh, Search} from 'vant';

export default {
  mixins: [
    Size
  ],
  components: {
    [List.name]: List,
    [Search.name]: Search,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      page: 1,
      orders: [],
      keyword: '',

      loading: false,
      finished: false,
      refreshing: false
    };
  },
  mounted() {
    window.document.title = '速电通-我的订单';
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
    },
    keywordChange() {
      this.refresh();
    },
    loadData() {
      if (this.refreshing) {
        this.orders = [];
        this.refreshing = false;
      }

      this.loading = true;
      myOrders(this.keyword, '', this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          response.data.body.data = response.data.body.data.map(value => {
            value.totalMoney = value.serviceMoney + value.electricMoney;
            value.startDatetime = value.startDatetime.substr(0, 16);
            value.endDatetime = value.endDatetime ? value.endDatetime.substr(0, 16) : '';
            if (value.status === 10) {
              value.statusShow = '已完成';
            } else {
              value.statusShow = '进行中';
              value.startDatetime = value.startDatetime.substr(11, 5);
            }
            return value;
          });

          this.orders = this.page === 1 ? response.data.body.data : this.orders.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.loading = false).catch(() => this.finished = true);
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" id="charge-order">
    <van-search v-model="keyword" @search="keywordChange" @clear="keywordChange" clearable left-icon="search" shape="round" placeholder="请输入订单编号"/>
    <van-list v-model="loading" :finished="finished" :finished-text="orders.length === 0 ? '' : '没有更多了'" @load="loadData">
      <div class="item" v-for="(order, index) in orders" :key="index">
        <div class="top">
          <div class="left">
            <div class="title">{{ order.stationName }}</div>
            <div class="description">订单编号:{{ order.shortSn }}</div>
          </div>
          <div class="status">{{ order.statusShow }}</div>
        </div>
        <div class="v-split-line"></div>
        <div class="row">
          <div class="column">
            <div class="label">充电电量</div>
            <div class="value">{{ order.chargeKwh }}度</div>
          </div>
          <div class="column">
            <div class="label">充电金额</div>
            <div class="value">{{ order.totalMoney }}元</div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="label">开始时间</div>
            <div class="value">{{ order.startDatetime }}</div>
          </div>
          <div class="column">
            <div class="label">{{ order.status === 10 ? '结束时间' : '剩余时间' }}</div>
            <div class="value">{{ order.status === 10 ? order.endDatetime : order.surplusMinutes + '分钟' }}</div>
          </div>
        </div>
      </div>
    </van-list>
    <div v-if="orders.length === 0" :style="{height: (height - 54) + 'px'}" class="no-data">
      <div class="content">
        <img src="../assets/images/no-data.png"/>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#charge-order {
  background-color: #F6F9F8;
}

#charge-order .item {
  padding: 12px;
  border-radius: 8px;
  background-color: white;
  margin: 12px 12px 0 12px;
}

#charge-order .item .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#charge-order .item .top .left {
  display: flex;
  flex-direction: column;
}

#charge-order .item .top .left .title {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
}

#charge-order .item .top .left .description {
  color: #999999;
  font-size: 14px;
  margin-top: 8px;
  font-weight: 500;
}

#charge-order .item .top .status {
  color: #009251;
  font-size: 16px;
  font-weight: bold;
}

#charge-order .item .v-split-line {
  height: 0;
  width: 100%;
  margin: 12px 0;
  border-top: 1px solid #EEEEEE;
}

#charge-order .item .row {
  display: flex;
  margin-top: 8px;
}

#charge-order .item .column {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#charge-order .item .column .label {
  color: #999999;
  font-size: 14px;
  font-weight: 500;
}

#charge-order .item .column .value {
  color: #666666;
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
}
</style>

